import { render, staticRenderFns } from "./FInfoText.vue?vue&type=template&id=6d38262a&"
import script from "./FInfoText.vue?vue&type=script&lang=ts&"
export * from "./FInfoText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports